
const firebaseConfig = {
    apiKey: "AIzaSyDy6E2l7OrFnkPvG6uaXrAw5MyD5vjMD74",
    authDomain: "bostadsvaljare-ekeblad-rebla.firebaseapp.com",
    projectId: "bostadsvaljare-ekeblad-rebla",
    storageBucket: "bostadsvaljare-ekeblad-rebla.appspot.com",
    messagingSenderId: "736149422933",
    appId: "1:736149422933:web:092e2a5e40b39f2a1465dc",
    measurementId: "G-4CNVZY3JYG"
};

// const firebaseConfig = {
//     apiKey: "AIzaSyC7HUfblTTJKvBWINyDxwmZbUfZPhcX0vM",
//     authDomain: "test-rebla.firebaseapp.com",
//     projectId: "test-rebla",
//     storageBucket: "test-rebla.appspot.com",
//     messagingSenderId: "674551819684",
//     appId: "1:674551819684:web:24cfd50b46bf97ebfb6531"
// };

exports.config = firebaseConfig;